const inflight = new Map<string, Promise<unknown>>();

/**
 * Collapse concurrent identical requests into one in-flight promise.
 * Cleared when the promise settles so later calls may refetch.
 */
export function coalesceRequest<T>(key: string, run: () => Promise<T>): Promise<T> {
  const existing = inflight.get(key);
  if (existing) {
    return existing as Promise<T>;
  }

  const promise = run().finally(() => {
    inflight.delete(key);
  });
  inflight.set(key, promise);
  return promise;
}

/** Test helper — reset coalescing between Vitest cases. */
export function resetRequestCoalescerForTests(): void {
  inflight.clear();
}
